import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

export type EditActivityTagSuccessModalProps = Readonly<{
  isOpen: boolean
  handleClose: () => void
}>

export function EditActivityTagSuccessModal({ isOpen, handleClose }: EditActivityTagSuccessModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={isOpen} onClose={handleClose} aria-labelledby="edit-activity-tag-success">
      <AcknowledgeModal
        result="positive"
        title={t('typography.activityTagUpdatedTitle')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="edit-activity-tag-success-modal-btn"
      >
        {t('typography.activityTagUpdatedDescription')}
      </AcknowledgeModal>
    </Modal>
  )
}
